import { AlertTriangle } from 'lucide-react';
import { Badge } from './ui/badge';

export function MissingDatesWarning({ data, dateField = 'date', year, month, dateFrom, dateTo, onDateClick }) {
  // Determine the date range to check
  const today = new Date();
  let startDate, endDate;

  if (year && month) {
    startDate = new Date(year, month - 1, 1);
    endDate = new Date(year, month, 0); // last day of month
  } else if (dateFrom && dateTo) {
    startDate = new Date(dateFrom);
    endDate = new Date(dateTo);
  } else {
    // No specific period selected — don't show warning
    return null;
  }

  // Don't check future dates
  if (endDate > today) endDate = today;
  if (startDate > today) return null;

  // Build list of all dates in range
  const allDates = [];
  const current = new Date(startDate);
  while (current <= endDate) {
    allDates.push(current.toISOString().split('T')[0]);
    current.setDate(current.getDate() + 1);
  }

  if (allDates.length === 0) return null;

  // Get dates with data
  const datesWithData = new Set(data.map(item => item[dateField]));

  // Find missing dates
  const missingDates = allDates.filter(d => !datesWithData.has(d));

  if (missingDates.length === 0) return null;

  const formatShort = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' });
  };

  return (
    <div className="flex items-start gap-3 p-3 rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800" data-testid="missing-dates-warning">
      <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-300">
          {missingDates.length} jour{missingDates.length > 1 ? 's' : ''} sans saisie
        </p>
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {missingDates.map(d => (
            <Badge
              key={d}
              variant="outline"
              data-testid={`missing-date-${d}`}
              className={`text-xs border-amber-300 text-amber-700 dark:text-amber-400 bg-amber-100/50 dark:bg-amber-900/30 ${onDateClick ? 'cursor-pointer hover:bg-amber-200 dark:hover:bg-amber-800/50 transition-colors' : ''}`}
              onClick={onDateClick ? () => onDateClick(d) : undefined}
            >
              {formatShort(d)}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
}
